import { range, flatten } from 'lodash';
import { setAngle, setAngleOffset, setRadius, setStrokeWidth, setGenerations, setThematic } from '../chart';
import { setThickness, setFontSize, setOffset, setCellType, setStrokeVisible } from '../generations'
import { setInverted, batchUpdateCells } from '../cells';

export function update(dispatch, getState) {
  updateChart(dispatch);
  updateGenerations(dispatch);
  updateCells(dispatch);
}

export const settings = {
  name: '192° Fan Chart',
  angle: 192,
  angleOffset: 0,
  strokeWidth: 2,
  font: 'Nunito',
  generations: 9,
}

function updateChart(dispatch) {
  dispatch(setAngle(settings.angle));
  dispatch(setAngleOffset(settings.angleOffset));
  dispatch(setThematic(null));
}

export const generations = [
  {
    thickness: 80,
    fontSize: 16,
    cellType: 'horizontal-multiline',
    offset: 0,
  },
  {
    thickness: 120,
    fontSize: 16,
    cellType: 'horizontal-date',
    offset: 0,
  },
  {
    thickness: 120,
    fontSize: 16,
    cellType: 'horizontal-date',
    offset: 0,
  },
  {
    thickness: 130,
    fontSize: 14,
    cellType: 'horizontal-date',
    offset: 0,
  },
  {
    thickness: 150,
    fontSize: 12,
    cellType: 'vertical-date',
    offset: 0,
  },
  {
    thickness: 150,
    fontSize: 10,
    cellType: 'vertical-date',
    offset: 0,
  },
  {
    thickness: 150,
    fontSize: 10,
    cellType: 'vertical-inline-date',
    offset: 0,
  },
  {
    thickness: 160,
    fontSize: 10,
    cellType: 'vertical-inline-date',
    offset: 0,
  },
  {
    thickness: 160,
    fontSize: 8,
    cellType: 'vertical-inline-date',
    offset: 0,
  },
  {
    thickness: 160,
    fontSize: 8,
    cellType: 'vertical-inline-date',
    offset: 0,
  }
]

function updateGenerations(dispatch) {
  generations.forEach((generation, i) => {
    dispatch(setThickness(i, generation.thickness));
    dispatch(setFontSize(i, generation.fontSize));
    dispatch(setCellType(i, generation.cellType));
    dispatch(setOffset(i, generation.offset));
  });
}

function updateCells(dispatch) {
  const cellUpdates = flatten(range(0, 10).map(generation => {
    const n = Math.pow(2, generation);
    const halfN = n / 2;
    return range(0, n).map(index => ({
      ascendancy: n + index,
      inverted: generation > 3 && index < halfN,
    }))
  }))
  dispatch(batchUpdateCells(cellUpdates));
}


// WEBPACK FOOTER //
// ./src/core/templates/fanchart.js